import { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';
import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { StelmachPreset } from './primeng-preset';
import { provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { provideTranslateService, provideTranslateLoader } from '@ngx-translate/core';
import { provideServiceWorker } from '@angular/service-worker';
import { MessageService, ConfirmationService } from 'primeng/api';

import { environment } from '@env/environment';
import { env } from '@env/env';

import { HttpService } from './core/http';
import { CORE_INTERCEPTORS } from './core/http/interceptors';
import { TranslateLoaderOverrid } from './i18n';
import { routes } from './app.routes';

import { provideUserStore } from '@app/store/user';
import { provideGuiStore } from '@app/store/gui';
import { provideDictionariesStore } from '@app/store/dictionaries';
import { providePrivilegesStore } from '@app/store/privileges';
import { provideProductsSyncStore } from '@app/store/products-sync';

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(routes),
        provideHttpClient(withInterceptors([...CORE_INTERCEPTORS])),
        provideAnimationsAsync(),
        providePrimeNG({
            ripple: true,
            theme: {
                preset: StelmachPreset,
                options: {
                    darkModeSelector: false,
                },
            },
        }),
        provideStore(),
        provideEffects(),
        ...provideUserStore(),
        ...provideGuiStore(),
        ...provideDictionariesStore(),
        ...providePrivilegesStore(),
        ...provideProductsSyncStore(),
        MessageService,
        ConfirmationService,
        provideStoreDevtools({
            maxAge: 25,
            logOnly: environment.production,
            connectInZone: true,
        }),
        provideTranslateService({
            defaultLanguage: env.defaultLanguage,
        }),
        provideTranslateLoader(TranslateLoaderOverrid),
        provideServiceWorker('./ngsw-worker.js', {
            enabled: environment.sw,
            registrationStrategy: 'registerWhenStable:30000',
        }),
        {
            provide: HttpClient,
            useClass: HttpService,
        },
    ],
};
